// extracted by css-extract-rspack-plugin
export default {"container":"_22bd0f30","visible":"_9e0fead9","messageBody":"_3ffb694c","title":"_f897b337"};